import type { NotificationProps } from '@/types/notification';
import type { RouteLocationAsPathGeneric, RouteLocationAsRelativeGeneric } from 'vue-router';

interface NotificationStore {
	message: NotificationProps
}

export const useNotificationStore = defineStore('notification', {
	state: (): NotificationStore => ({
		message: {
			header: '',
			content: '',
			type: NOTIFICATION_TYPE.SUCCESS,
			isShow: false,
			isShowDismiss: false,
			link: '',
			linkName: '',
		},
	}),

	actions: {
		showNotification(data: NotificationProps) {
			this.message = data;
		},

		hideNotification() {
			this.message = {
				...this.message,
				isShow: false,
			};
		},

		showSuccessNotification(
			title: string,
			message: string = '',
			isShowDismiss: boolean = false,
			link: string | RouteLocationAsRelativeGeneric | RouteLocationAsPathGeneric = '',
			linkName: string = 'Learn more',
		) {
			this.showNotification({
				header: title,
				content: message,
				type: NOTIFICATION_TYPE.SUCCESS,
				isShow: true,
				isShowDismiss,
				link,
				linkName,
			});
		},

		showErrorNotification(
			title: string,
			message: string = '',
			isShowDismiss: boolean = false,
			link: string = '',
			linkName: string = 'Learn more',
		) {
			this.showNotification({
				header: title,
				content: message,
				type: NOTIFICATION_TYPE.ERROR,
				isShow: true,
				isShowDismiss,
				link,
				linkName,
			});
		},

		showWarningNotification(
			title: string,
			message: string = '',
			isShowDismiss: boolean = false,
			link: string = '',
			linkName: string = 'Learn more',
		) {
			this.showNotification({
				header: title,
				content: message,
				type: NOTIFICATION_TYPE.WARNING,
				isShow: true,
				isShowDismiss,
				link,
				linkName,
			});
		},

		showInfoNotification(
			title: string,
			message: string = '',
			isShowDismiss: boolean = false,
			link: string = '',
			linkName: string = 'Learn more',
		) {
			this.showNotification({
				header: title,
				content: message,
				type: NOTIFICATION_TYPE.INFO,
				isShow: true,
				isShowDismiss,
				link,
				linkName,
			});
		},
	},
});
